import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "../../../css/styles.css";
import InvestmentBuySellConfirmCard from './investment_buySell_confirm_card';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import investmentMoodPointsDataset from './datasets/investment_mood_points';
import findArrayDuplicates from '../../../objects/CommonUse/find_array_duplicates';


class InvestmentBuySellConfirmModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                 moodPointArr: investmentMoodPointsDataset
              } 
        this.infoType = "label-quantity-amount-amount";
        this.determineTotalAmounts();
        this.determineModalText();
    }

    determineTotalAmounts(){
        this.determineTotalInvestmentAmt();
        let totalTransactionAmt = +this.totalTransactionAmt;
        if (this.props.tranType === "buy"){
            totalTransactionAmt = -1 * +this.totalTransactionAmt;
        }
        this.buySellObj = {totalAmt: totalTransactionAmt};
    }

    determineTotalInvestmentAmt(){
        this.errorFound = false;
        this.totalTransactionAmt = 0;
        this.coupon = false;
        this.totalCouponAmt = 0;
        for (let i=0; i<this.props.purchaseArr.length; i++){
            this.totalTransactionAmt += +this.props.purchaseArr[i].totalAmount;
            if (this.props.purchaseArr[i].coupon === true){
                this.coupon = true;
                this.totalCouponAmt += +this.props.purchaseArr[i].totalCouponAmt;
            }
        }
        this.totalLineClass = "p-0 text-right ";
        this.positiveTotalTranAmt = this.totalTransactionAmt;
        if (this.props.tranType === "buy"){
            if (+this.totalTransactionAmt > +this.props.currentCash){
                this.errorFound = true;
                this.errorClass = "text-right text-danger";
                this.errorMsg = "Total amount of purchase exceeds current cash.";
            }
        }
        if (this.props.tranType === "sell"){
            this.checkForMultiplePurchases();
        }
    }

    checkForMultiplePurchases(){
        let displayWarning = false;
        const duplicateEntries = findArrayDuplicates(this.props.purchaseArr, "investmentName");
        if (duplicateEntries.length > 0){
            duplicateEntries.sort((a, b) => 
                (a.investmentName + +a.transNbr > b.investmentName + +b.transNbr) ? 1 : -1);
            for (let i=0; i<duplicateEntries.length; i+=2){
                if (+duplicateEntries[i].quantity < +duplicateEntries[i].initialBuyQty){
                    displayWarning = true;
                    break;
                }
            }
        }
        if (displayWarning === true){
            this.errorMsg = "Heads up: Sell transactions use the First-In, First-Out (FIFO) method. " +
                "This means your sales will be applied to the shares you've held for the longest time."
            this.errorClass = "text-left warning-box";
        }
    }


    determineModalText(){
        switch (this.props.investType){
            case "stock":
                this.investType = "Stocks";
                break;
            case "bond":
                this.investType = "Bonds";
                break;
            case "index":
                this.investType = "Index Funds";
                break;
            case "mutualfund":
                this.investType = "Mutual Funds";
                break;
            default:
                break;
        }   
        if (this.props.tranType === "buy"){
            this.headerText = "Confirm Purchases of " + this.investType;
            this.buttonText = "Confirm Purchases";
        }else{
            this.headerText = "Confirm Sales of " + this.investType;
            this.buttonText = "Confirm Sales";
        }
    }
 
    render() {
        
         this.investmentPurchaseAmounts = this.props.purchaseArr.map((purchaseAmts, index) =>
              <InvestmentBuySellConfirmCard key={index} tableInfo={purchaseAmts} 
                    infoType={this.infoType} couponSw={this.coupon}
               />
            );  
    return <>  
      <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="md" scrollable="true"
            dialogClassName="modal-with-rounded-corners" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title className="text-center">{this.headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div >
                    <div>
                        <span className="font-weight-bold">Current Cash:</span>
                        <span className="ml-4">{doubleToStringMonthly(this.props.currentCash)}</span>
                    </div>
                 
                    <div >
                        <table className="table table-hover table-no-space">
                            <tbody>
                                <tr>
                                    <th className="text-center">Investment Name</th>
                                    <th className="text-center ml-2">Qty</th>
                                    <th className="text-center ml-2">Unit Price</th>
                                    {this.coupon === true ?
                                        <th className="text-center ml-2">Coupon Amt</th>
                                    :
                                        null
                                    }
                                    <th className="text-center ml-2">Total Amount</th>
                                </tr>
                                {this.investmentPurchaseAmounts}
                                <tr className="table-blank-line ">
                                </tr>
                                <tr className="text-left p-0 ">
                                    <th className="text-left">Total Amount</th>
                                    <td className="text-right p-0"></td>
                                    <td className="text-right p-0"></td>
                                    {this.coupon === true   ?
                                     <td className={this.totalLineClass}>
                                        {doubleToStringMonthly(this.totalCouponAmt)}
                                     </td>
                                    :
                                        null
                                    }
                                    <td className={this.totalLineClass}>
                                        {doubleToStringMonthly(this.totalTransactionAmt)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  
                    </div>
                </div>
        </Modal.Body>
         <Modal.Footer className="backgroundTopBottom">
            <div className={this.errorClass}>
                {this.errorMsg}
            </div>
            {this.errorFound === false  ?
                <Button variant="secondary"  onClick={() => this.props.confirmBuyOrSell(this.buySellObj)}>
                        {this.buttonText}
                </Button>
            :
                    null
            }
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                      Back
            </Button>
        </Modal.Footer>
        </Modal>
        
        </>
    }

    
}

export default InvestmentBuySellConfirmModal;